module.exports = "<div id=\"pageInfo\">\n  Welcome to Cat World.\n</div>\n"